import buildPropertyRatesKey from 'lib/offer/buildPropertyRatesKey'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from './reduxHooks'
import { fetchPropertyRatesList } from 'actions/PropertyActions'
import { EmptyArray } from 'lib/array/arrayUtils'
import usePropertyOfferMapping from './Offers/usePropertyOfferMapping'

interface Options {
  checkIn?: string;
  checkOut?: string;
  occupancies?: Array<App.Occupants> | App.Occupants;
  dynamicAvailability?: boolean;
  disabled?: boolean;
}

function usePropertyRatesList(propertyId: string | undefined, options: Options): [Array<App.PropertyRateListRate>, boolean, any] {
  const dispatch = useAppDispatch()

  const [mapping] = usePropertyOfferMapping(propertyId)
  const accommodationPropertyId = mapping?.accommodationPropertyId
  const key = buildPropertyRatesKey(accommodationPropertyId, {
    checkIn: options.checkIn,
    checkOut: options.checkOut,
    occupancies: options.occupancies,
    dynamicAvailability: options.dynamicAvailability,
  })
  const record = useAppSelector(state => state.offer.propertyRatesLists[key])

  useEffect(() => {
    if (!options.disabled &&
      options.checkIn &&
      options.checkOut &&
      options.occupancies &&
      accommodationPropertyId
    ) {
      dispatch(fetchPropertyRatesList(accommodationPropertyId, {
        checkIn: options.checkIn,
        checkOut: options.checkOut,
        occupancies: options.occupancies,
        dynamicAvailability: !!options.dynamicAvailability,
      }))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, options.disabled])

  return [
    record?.rates ?? EmptyArray,
    !!record?.fetching,
    record?.error,
  ]
}

export default usePropertyRatesList
